import React from "react";


const TextFilter: React.FC<{ label?: string, filterText: string, onFilter: (text: string) => void, onClear: () => void }> = ({ label, filterText, onFilter, onClear }) => {

    return (
        <div className="flex flex-col gap-1 items-start">
            {label && <label className="text-xs font-semibold text-gray-600 ml-1">{label}</label>}
            <div className="flex items-center">
                <input
                    value={filterText}
                    onChange={(e) => onFilter(e.target.value)}
                    placeholder="Buscar..."
                    className="border border-gray-300 p-2 rounded-lg w-64 text-sm"
                />
                <button onClick={onClear} className="bg-gray-300 p-2 rounded-lg ml-2 text-sm">Limpiar</button>
            </div>
        </div>
    );
}

export default TextFilter;